import { useGlobalStore } from '../../stores/useGlobalStore';

import { contact } from './endpoints';

import { makeAuthenticatedPostRequest } from './index';

export const logout = () => {
  useGlobalStore.getState().setUser(null);
};

export const sendUpgradeRequest = async () => {
  return await makeAuthenticatedPostRequest(contact, {
    message: 'Request for Upgrade',
  });
};
